import { z } from 'zod';
/**
 * Shape the LLM must return in Mode D. Anything that fails this parse is retried once
 * and then treated as a job failure — see mode-d-prompting.md.
 */
export const GeneratedFile = z.object({
    path: z.string().min(1),
    contents: z.string(),
});
export const CodegenGap = z.object({
    what: z.string().min(1),
    severity: z.enum(['partial', 'miss']),
});
export const CodegenResponse = z.object({
    files: z.array(GeneratedFile).min(1),
    gaps: z.array(CodegenGap).default([]),
});
/**
 * The only packages a generated customer project may depend on.
 * Widening this list is a code + docs change, never a model decision (security-spec.md).
 */
export const GENERATED_DEPENDENCY_ALLOWLIST = [
    'react',
    'react-dom',
    'react-router-dom',
    'motion',
    // Framer's own smooth-scrolling setting ships this library. A page captured with it running
    // cannot be reproduced without it, and reimplementing the easing would be a guess where the
    // transpiler otherwise only measures.
    'lenis',
    'vite',
    '@vitejs/plugin-react',
    'typescript',
    '@types/react',
    '@types/react-dom',
];
export function isAllowedDependency(name) {
    return GENERATED_DEPENDENCY_ALLOWLIST.includes(name);
}
//# sourceMappingURL=codegen.js.map